<template>
	<div id="app">
		<router-view />
		<Contact v-if="showContactUs" :contact="commonContent.contactInfo" />
		<div class="container disclaimers-footnotes">
			<Terms
				v-if="showDisclaimersAndFootnotes"
				:disclaimerItems="disclaimerItems"
				:footnoteItems="footnoteItems"
				class="md-offset-right-1"
			/>
		</div>
		<StickyFooter scrollAmountPercent="25" v-if="showRetailClientFooter" @closeClicked="stickyFooterClosed">
			<p class="p2" v-html="commonContent.retailClientFooter.text"></p>
		</StickyFooter>
		<Modal />
	</div>
</template>

<script>
import "@vg-faset/core/styles/main.scss";
import Terms from "@vg-faset/ui/src/components/terms/Terms.vue";
import Modal from "@vg-faset/ui/src/components/modal/Modal.vue";
import Contact from "@vg-faset/ui/src/components/contact/Contact.vue";
import formatItemArray from "./mixins/formatItems.js";
import StickyFooter from "@vg-faset/ui/src/components/sticky-footer/StickyFooter";

export default {
	name: "App",
	components: {
		Contact,
		Terms,
		Modal,
		StickyFooter
	},
	mixins: [formatItemArray],
	metaInfo() {
		const pageTitle = this.$route.meta.pageTitle;

		return {
			title: pageTitle ? `${pageTitle} | Tax Center | Vanguard Advisors` : "Tax Center | Vanguard Advisors",
			meta: [
				{ vmid: "description", name: "description", content: this.content.pageDescription },
				{ vmid: "keywords", name: "keywords", content: this.content.keywords }
			]
		};
	},
	computed: {
		commonContent() {
			return this.$store.state.commonContent;
		},
		content() {
			return this.$store.state.content;
		},
		footnoteItems: function () {
			return this.formatItemArray(this.content.disclaimersAndFootnotes.footnotes);
		},
		disclaimerItems: function () {
			return this.formatItemArray(this.content.disclaimersAndFootnotes.disclaimers);
		},
		showDisclaimersAndFootnotes() {
			return (
				this.content.disclaimersAndFootnotes && this.hasFootnoteOrDisclaimer && this.$route.name !== "PageUnavailable"
			);
		},
		showContactUs() {
			return this.commonContent.contactInfo && this.$route.name !== "PageUnavailable";
		},
		hasFootnoteOrDisclaimer() {
			return this.footnoteItems.length > 0 || this.disclaimerItems.length > 0;
		},
		showRetailClientFooter() {
			let footerHasBeenClosed = sessionStorage.getItem("footerClosed");
			return this.commonContent.retailClientFooter && !footerHasBeenClosed && this.$route.name !== "PageUnavailable";
		}
	},
	methods: {
		stickyFooterClosed() {
			sessionStorage.setItem("footerClosed", true);
		}
	}
};
</script>

<style lang="scss">
.disclaimers-footnotes {
	a {
		text-decoration: underline;
	}
}

@media (min-width: 1025px) {
	.col .hero .container {
		margin: 0 23px;
	}
}

@media (min-width: 1326px) {
	.col .hero .container {
		margin: 0 auto;
	}
}

.button--simple {
	&:hover,
	&:focus {
		text-decoration: none;
	}
}

.button--simple {
	&:hover,
	&:focus {
		:not(.icon-up):not(.icon-down) {
			text-decoration: underline;
		}
	}
}

.sticky-footer {
	a {
		color: $color--neutral-10;
		text-decoration: underline;
	}
}
</style>
